import * as React from 'react'
import { FieldError, FieldErrorsImpl, Merge } from 'react-hook-form'
import './styles.scss'

export interface InputRootProps extends React.ComponentPropsWithRef<'input'> {
  variant?: 'light' | 'dark' | 'light-normal' | 'light-normal-check'
  errors?: FieldError | Merge<FieldError, FieldErrorsImpl<any>> | undefined
  children: React.ReactNode
  label?: string
}

export const InputRoot = ({
  variant = 'light',
  readOnly = false,
  errors,
  children,
  label,
  ...rest
}: InputRootProps) => {
  const enhancedChildren = React.Children.map(children, (child) => {
    if (React.isValidElement(child)) {
      return React.cloneElement(child, { ...rest })
    }
    return child
  })

  return (
    <div className="input-component">
      {!!label && <label>{label}</label>}
      <div
        className={`input-container input-${variant} ${
          errors && 'input-error'
        } ${readOnly && 'read-only'}`}
      >
        {enhancedChildren}
      </div>
      <div className="span-error-container">
        {errors?.message && (
          <span className="input-error-span">{errors.message.toString()}</span>
        )}
      </div>
    </div>
  )
}
